import { useTranslation } from "react-i18next";

import { currencySymbol as businessCurrencySymbol } from "../../../utils/currency";
import SegmentedToggleInput from "./SegmentedToggleInput";

export default function DiscountTypeToggleInput({
  label = "Discount Type",
  register,
  registerName,
  setValue,
  watch,
  classes = "",
  currencySymbol = businessCurrencySymbol(),
  percentageSymbol = "%",
}) {
  const { t } = useTranslation("common");

  return (
    <SegmentedToggleInput
      label={t(label)}
      register={register}
      registerName={registerName}
      setValue={setValue}
      watch={watch}
      classes={classes}
      options={[
        { value: "flat", label: currencySymbol },
        { value: "percentage", label: percentageSymbol },
      ]}
      widthClass="w-28"
      heightClass="h-[38px]"
      indicatorWidthClass="w-[calc(50%-3px)]"
      containerClass="flex"
      borderClass="border-gray-300"
      backgroundClass="bg-white"
      indicatorClass="bg-primary-600"
      textClass="text-gray-700"
      activeTextClass="text-white"
      ariaLabel={t("Discount type toggle")}
    />
  );
}
